import { useEffect, useState } from "react";
import { API } from "../../api/API";
import { getData } from "../../CommonElements/Functions/PostGetFun";
import { useSelector } from "react-redux";
import { RootState } from "../../redux-toolkit/store";
import { Card, Input } from "reactstrap";
import CardHeaderSpan from "../../Utils/CommonComponents/CardHeaderSpan";
import FeatherIconCom from "../../Utils/CommonComponents/CommonIcons/FeatherIconCom";
import DatePicker from "react-datepicker";
import TreeModel from "../Dashboards/Attendance/AttendanceTable/TreeModel";
import { getFilteredPositionIds } from "../../db/DexieServises";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import DARReport from "./DARReport";
import CommonModal from "../../CommonElements/Functions/CommonModels";
import { dynamicImage } from "../../Utils";
import { Image } from "../../AbstractElements";

const EmployeeAttendaceReport = () => {
  interface AttendanceEntry {
    date: string;
    total_calls: number;
    status: string;
    type: string;
    remarks?: string;
    full_date: string | number;
  }

  // ✅ FIX: Local date formatter (avoids UTC issue)
  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Truncate text to 15 characters with ellipsis
  const truncateText = (
    text: string | null | undefined,
    maxLength: number = 15,
  ): string => {
    if (!text) return "-";
    return text.length > maxLength
      ? `${text.substring(0, maxLength)}...`
      : text;
  };
  const normalizeDesignation = (value: unknown): string => {
    if (typeof value !== "string") return "";
    return value.trim().toLowerCase();
  };
  const truncateText2 = (
    text: string | null | undefined,
    maxLength: number = 8,
  ): string => {
    if (!text) return "-";
    return text.length > maxLength
      ? `${text.substring(0, maxLength)}...`
      : text;
  };
  const normalizeDesignation2 = (value: unknown): string => {
    if (typeof value !== "string") return "";
    return value.trim().toLowerCase();
  };

  const [tableData, setTableData] = useState<any[]>([]);
  const [displayedData, setDisplayedData] = useState<any[]>([]);
  const [modalOpen1, setModalOpen1] = useState(false);
  const [dates, setDates] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedDesignation, setSelectedDesignation] = useState("");
  const [selectedIds, setSelectedIds] = useState<(string | number)[]>([]);

  const today = new Date();
  const thirtyDaysAgo = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);

  const [fromDate, setFromDate] = useState<Date>(thirtyDaysAgo);
  const [toDate, setToDate] = useState<Date>(today);

  const unitId = useSelector((state: RootState) => state.orgUnit.id);
  const serverUrl = localStorage.getItem("serverUrl");

  // Fetch position IDs when unitId changes
  useEffect(() => {
    const fetchPositionIds = async () => {
      if (unitId) {
        const ids = await getFilteredPositionIds("Position", unitId);
        setSelectedIds(ids);
      }
    };
    fetchPositionIds();
  }, [unitId]);

  // Fetch pending attendance report
  useEffect(() => {
    if (!fromDate || !toDate) return;

    const fetchPendingAttendanceReport = async () => {
      try {
        setLoading(true);

        const positionIds =
          selectedIds.length > 0
            ? selectedIds.join(",")
            : (await getFilteredPositionIds("Position", unitId)).join(",");

        const params = {
          position_id: positionIds,
          date_raange: `${formatDate(fromDate)}_${formatDate(toDate)}`,
        };

        const url = `${serverUrl}${API.PendingAttendanceReport}`;
        const { status, data } = await getData(url, true, params);

        if (status === 200 && data?.data) {
          console.log("API Data:", data?.data);

          const apiData = data.data;

          setDates(apiData.displayDates || []);

          const rows = Object.values(apiData.employeeData).map((emp: any) => ({
            employee_id: emp.employee_id,
            employee_code: emp.employee_code,
            employee_name: emp.employee_name,
            position_name: emp.position_name,
            full_date: emp.full_date,
            position_id: emp.position_id,
            branch_name: emp.branch_name ?? "-",
            attendance: apiData.attendanceMatrix[emp.employee_id] || {},
          }));

          setTableData(rows);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchPendingAttendanceReport();
  }, [fromDate, toDate, serverUrl, selectedIds, unitId]);

  const designationOptions: { key: string; label: string }[] = Array.from(
    tableData.reduce((map: Map<string, string>, item: any) => {
      const label = item?.position_name;
      if (typeof label !== "string") return map;

      const cleanedLabel = label.trim();
      const key = normalizeDesignation(cleanedLabel);
      if (!key) return map;

      if (!map.has(key)) {
        map.set(key, cleanedLabel);
      }
      return map;
    }, new Map<string, string>()),
  )
    .map(([key, label]) => ({ key, label }))
    .sort((a, b) => a.label.localeCompare(b.label));

  // Filter data based on search text + selected designation key
  useEffect(() => {
    const lower = searchText.toLowerCase();

    const filteredBySearch = tableData.filter((item) => {
      const employeeCode = item?.employee_code?.toString().toLowerCase() ?? "";
      const employeeName = item?.employee_name?.toString().toLowerCase() ?? "";
      const positionName = item?.position_name?.toString().toLowerCase() ?? "";
      const branch_name = item?.branch_name?.toString().toLowerCase() ?? "";

      return (
        employeeCode.includes(lower) ||
        employeeName.includes(lower) ||
        positionName.includes(lower) ||
        branch_name.includes(lower)
      );
    });

    const filtered = selectedDesignation
      ? filteredBySearch.filter(
        (item) =>
          normalizeDesignation(item?.position_name) === selectedDesignation,
      )
      : filteredBySearch;

    setDisplayedData(filtered);
  }, [searchText, tableData, selectedDesignation]);

  useEffect(() => {
    const hasSelection = selectedDesignation !== "";
    const exists = designationOptions.some(
      (option) => option.key === selectedDesignation,
    );
    if (hasSelection && !exists) {
      setSelectedDesignation("");
    }
  }, [designationOptions, selectedDesignation]);

  // Get cell color based on attendance status (ARGB format)
  const getAttendanceColor = (status: string): string => {
    if (status === "YES") return "FF92D050"; // Green
    if (status === "NO") return "FFFF6B6B"; // Red
    if (
      status === "WEEK OFF" ||
      status === "CL" ||
      status === "PL" ||
      status === "SL"
    )
      return "FFFFEB9C"; // Yellow/Orange
    if (status === "NA") return "FFD9D9D9"; // Light gray
    return "FFFFFFFF"; // White (default)
  };

  // Export to Excel with colors
  const handleExportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Pending Attendance");

    // Define fixed columns
    const columns: Partial<ExcelJS.Column>[] = [
      { header: "Emp Code", key: "empCode", width: 12 },
      { header: "Emp Name", key: "empName", width: 20 },
      { header: "Designation", key: "designation", width: 18 },
      { header: "Branch Name", key: "branch_name", width: 12 },
    ];

    // Add date columns
    dates.forEach((date, index) => {
      columns.push({ header: date, key: `date_${index}`, width: 12 });
    });

    worksheet.columns = columns;

    // Style header row
    const headerRow = worksheet.getRow(1);
    headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
    headerRow.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF4472C4" },
    };
    headerRow.alignment = { horizontal: "center", vertical: "middle" };
    headerRow.eachCell((cell) => {
      cell.border = {
        top: { style: "thin", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      };
    });

    // Add data rows
    displayedData.forEach((row) => {
      const rowData: Record<string, any> = {
        empCode: row.employee_code,
        empName: row.employee_name,
        designation: row.position_name,
        branch_name: row.branch_name,
      };

      // Add attendance for each date
      dates.forEach((displayDate, index) => {
        const attendanceEntry = Object.values(row.attendance).find(
          (att: any) => att.date === displayDate,
        ) as any;

        const type = attendanceEntry?.type;

        if (type === "absent") {
          rowData[`date_${index}`] = "ABSENT";
        } else if (type === "weekoff") {
          rowData[`date_${index}`] = "WEEK OFF";
        } else if (type === "leave") {
          rowData[`date_${index}`] = attendanceEntry?.status;
        } else if (type === "holiday" || type === "REPUBLIC DAY") {
          rowData[`date_${index}`] = attendanceEntry?.status || "HOLIDAY";
        } else {
          rowData[`date_${index}`] = attendanceEntry?.total_calls ?? "NA";
        }
      });

      const dataRow = worksheet.addRow(rowData);

      // Apply colors to cells
      dataRow.eachCell((cell, colNumber) => {
        cell.border = {
          top: { style: "thin", color: { argb: "FFD3D3D3" } },
          left: { style: "thin", color: { argb: "FFD3D3D3" } },
          bottom: { style: "thin", color: { argb: "FFD3D3D3" } },
          right: { style: "thin", color: { argb: "FFD3D3D3" } },
        };
        cell.alignment = { horizontal: "center", vertical: "middle" };

        // Apply color to attendance columns (column 5 onwards)
        if (colNumber > 4) {
          const displayDate = dates[colNumber - 5];
          const attendanceEntry = Object.values(row.attendance).find(
            (att: any) => att.date === displayDate,
          ) as any;

          const type = attendanceEntry?.type;
          const status = attendanceEntry?.status;

          let bgColor = "FFFFFFFF"; // Default white
          let fontColor = "FF000000"; // Default black
          let isBold = false;

          if (type === "absent" || status === "NO") {
            bgColor = "FFFF6B6B"; // Red
            fontColor = "FFFFFFFF";
            isBold = true;
          } else if (type === "present" || status === "YES") {
            bgColor = "FF92D050"; // Green
            fontColor = "FFFFFFFF";
            isBold = true;
          } else if (type === "weekoff" || status === "WEEK OFF") {
            bgColor = "FFFFEB9C"; // Yellow
          } else if (
            type === "holiday" ||
            type === "PL" ||
            type === "REPUBLIC DAY" ||
            status === "PL"
          ) {
            bgColor = "FF4472C4"; // Primary Blue
            fontColor = "FFFFFFFF";
            isBold = true;
          } else if (type === "leave") {
            bgColor = "FF4472C4"; // Info Cyan
            fontColor = "FFFFFFFF";
            isBold = true;
          } else if (status === "NA") {
            bgColor = "FFD9D9D9"; // Gray
          }

          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: bgColor },
          };
          cell.font = { color: { argb: fontColor }, bold: isBold };
        }
      });
    });

    // Generate buffer and save
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(
      blob,
      `Pending_Attendance_Report_${new Date().toISOString().split("T")[0]}.xlsx`,
    );
  };
  const [reportData, setReportData] = useState<{
    positionId: string;
    startDate: string;
  }>({
    positionId: "",
    startDate: "",
  });

  const handleOpenModal = (positionId: number | string, startDate: string) => {
    setReportData({
      positionId: String(positionId),
      startDate,
    });
    setModalOpen1(true);
  };

  return (
    <div className="page-body mt-5 p-2">
      <Card>
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center pt-4 pb-2">
          <CardHeaderSpan
            headingClassName="pb-0"
            back={true}
            heading="Employee Attendance Report"
            span="Pending Attendance Report"
          />
        </div>
        <div className="row mb-4 px-3 my-2 align-items-center justify-content-around g-2">
          <div className=" col-md-8 d-flex align-items-center gap-2 flex-wrap">
            <Input
              type="text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search by name or position"
              className="form-control form-control-sm"
              style={{ maxWidth: "250px", height: "35px" }}
            />
            <Input
              type="select"
              value={selectedDesignation}
              onChange={(e) => setSelectedDesignation(e.target.value)}
              className="form-select "
              style={{ maxWidth: "220px", height: "35px" }}
            >
              <option value="">All Designation</option>
              {designationOptions.map((option) => (
                <option key={option.key} value={option.key}>
                  {option.label}
                </option>
              ))}
            </Input>

            <TreeModel onSelectionChange={setSelectedIds} />
          </div>

          <div className=" col-md-4 d-flex align-items-center justify-content-end gap-3 ">
            <label className="form-label mb-0 small text-muted">From</label>
            <DatePicker
              selected={fromDate}
              onChange={(date: Date | null) => date && setFromDate(date)}
              maxDate={new Date()}
              dateFormat="dd-MM-yyyy"
              customInput={
                <input
                  className="form-control form-control-sm"
                  style={{ width: "120px", height: "35px" }}
                />
              }
            />
            <label className="form-label mb-0 small text-muted">To</label>
            <DatePicker
              selected={toDate}
              onChange={(date: Date | null) => date && setToDate(date)}
              maxDate={new Date()}
              dateFormat="dd-MM-yyyy"
              customInput={
                <input
                  className="form-control form-control-sm"
                  style={{ width: "120px", height: "35px" }}
                />
              }
            />
            <button
              className="btn btn-sm btn-primary align-items-center d-flex "
              onClick={handleExportToExcel}
            >
              <FeatherIconCom
                iconName={"Download"}
                size={14}
                className="text-light"
              />
              <span className="px-2" style={{ fontSize: 14 }}>
                Export
              </span>
            </button>
          </div>
        </div>
        {/* Filters Row
        <div className="d-flex justify-content-evenly align-items-start flex-wrap gap-3 px-3 mb-3">
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <Input
              type="text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search code, name, designation, HQ"
              className="form-control form-control-sm"
              style={{ width: "200px", minWidth: "180px" }}
            />
            <TreeModel onSelectionChange={setSelectedIds} />
          </div>

          <div className="d-flex align-items-end gap-2 flex-wrap">
            <div>
              <label className="form-label mb-0 small text-muted">From</label>
              <DatePicker
                selected={fromDate}
                onChange={(date: Date | null) => date && setFromDate(date)}
                maxDate={new Date()}
                dateFormat="yyyy-MM-dd"
                className="form-control form-control-sm"
              />
            </div>

            <div>
              <label className="form-label mb-0 small text-muted">To</label>
              <DatePicker
                selected={toDate}
                onChange={(date: Date | null) => date && setToDate(date)}
                maxDate={new Date()}
                dateFormat="yyyy-MM-dd"
                className="form-control form-control-sm"
              />
            </div>

            <button
              className="btn btn-sm btn-primary d-flex align-items-center gap-1"
              onClick={handleExportToExcel}
              style={{ whiteSpace: "nowrap" }}
            >
              <FeatherIconCom iconName="Download" size={14} />
              Export
            </button>
          </div>
        </div> */}

        {/* LEFT FIXED TABLE */}
        {loading ? (
          <div className="text-center py-3">
            <div>
              <Image
                className="b-r-10 img-80"
                src={dynamicImage("dashboard/loader.gif")}
                alt="Loading..."
              />
            </div>
          </div>
        ) : (
          <div style={{ display: "flex", alignItems: "flex-start" }}>
            <div style={{ flexShrink: 0, borderRight: "2px solid #dee2e6" }}>
              <table className="table table-bordered text-center align-middle mb-0">
                <thead className="table-success">
                  <tr style={{ height: "41px" }}>
                    <th className="text-nowrap px-2">Emp Code</th>
                    <th style={{ textAlign: "left" }}>Emp Name</th>
                    <th style={{ textAlign: "left" }}>Designation</th>
                    <th style={{ textAlign: "left" }}>HQ</th>
                  </tr>
                </thead>
                <tbody>
                  {displayedData.length > 0 ? (
                    displayedData.map((row, rowIndex) => (
                      <tr key={rowIndex} style={{ height: "41px" }}>
                        <td style={{ padding: "8px", verticalAlign: "middle" }}>
                          {row.employee_code}
                        </td>
                        <td
                          className="text-nowrap"
                          style={{
                            padding: "8px",
                            verticalAlign: "middle",
                            textAlign: "left",
                            cursor:
                              row.employee_name?.length > 15
                                ? "pointer"
                                : "default",
                          }}
                          title={row.employee_name || ""}
                        >
                          {truncateText(row.employee_name)}
                        </td>
                        <td
                          className="text-nowrap"
                          style={{
                            padding: "8px",
                            verticalAlign: "middle",
                            textAlign: "left",
                            cursor:
                              row.position_name?.length > 10
                                ? "pointer"
                                : "default",
                          }}
                          title={row.position_name || ""}
                        >
                          {truncateText(row.position_name)}
                        </td>
                        <td
                          style={{
                            padding: "8px",
                            verticalAlign: "middle",
                            textAlign: "left",
                            cursor:
                              row.branch_name?.toString().length > 10
                                ? "pointer"
                                : "default",
                          }}
                          title={row.branch_name?.toString() || ""}
                        >
                          {truncateText(row.branch_name?.toString())}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr style={{ height: "41px" }}>
                      <td
                        colSpan={4}
                        style={{ padding: "8px", verticalAlign: "middle" }}
                      >
                        {loading
                          ? "Loading..."
                          : "No attendance data available"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {/* Spacer to match scrollbar height */}
              <div style={{ height: "8px" }}></div>
            </div>

            {/* RIGHT SCROLLABLE TABLE */}
            <div style={{ flex: 1, overflowX: "auto", overflowY: "hidden" }}>
              <table className="table table-bordered text-center align-middle mb-0">
                <thead className="table">
                  <tr style={{ height: "41px" }}>
                    {dates.map((date, index) => (
                      <th className="text-nowrap" key={index}>
                        {date}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {displayedData.length > 0 ? (
                    displayedData.map((row, rowIndex) => (
                      <tr key={rowIndex} style={{ height: "41px" }}>
                        {dates.map((displayDate, i) => {
                          const attendanceEntry = (
                            Object.values(row.attendance) as AttendanceEntry[]
                          ).find((att) => att.date === displayDate);

                          const total_calls = attendanceEntry?.total_calls;
                          const full_date = attendanceEntry?.full_date;
                          const status = attendanceEntry?.status;
                          const type = attendanceEntry?.type;
                          // console.log("row",row[0]);

                          return (
                            <td
                              key={i}
                              // title={attendanceEntry?.remarks || ""}
                              title={status}
                              style={{
                                padding: "8px",
                                verticalAlign: "middle",
                                cursor: "pointer",
                              }}
                              // className={`small fw-normal ${
                              //   status === "YES"
                              //     ? "bg-success text-white"
                              //     : status === "NO"
                              //       ? "bg-danger text-white"
                              //       : status === "WEEK OFF" ||
                              //           status === "CL" ||
                              //           status === "PL" ||
                              //           status === "SL"
                              //         ? "bg-warning text-dark"
                              //         : ""
                              // }`}
                              className={`small fw-normal ${type === "present"
                                ? "bg-success text-white"
                                : type === "absent"
                                  ? "bg-danger text-white"
                                  : type === "holiday"
                                    ? "bg-primary text-white"
                                    : type === "leave"
                                      ? "bg-primary text-white"
                                      : type === "weekoff"
                                        ? "bg-warning text-dark"
                                        : type === "holiday"
                                          ? "bg-primary text-white"
                                          : ""
                                }`}
                              onClick={() => {
                                if (row?.position_id && full_date) {
                                  handleOpenModal(
                                    row.position_id,
                                    String(full_date),
                                  );
                                }
                              }}
                            >
                              {type === "weekoff"
                                ? "WEEK OFF"
                                : type === "absent"
                                  ? "ABSENT"
                                  : type === "REPUBLIC DAY"
                                    ? "HOLIDAY"
                                    : type === "leave"
                                      ? status
                                      : type === "holiday"
                                        ? truncateText2(status)
                                        : total_calls}
                            </td>
                          );
                        })}
                      </tr>
                    ))
                  ) : (
                    <tr style={{ height: "41px" }}>
                      <td
                        colSpan={dates.length}
                        style={{ padding: "8px", verticalAlign: "middle" }}
                      ></td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        <CommonModal
          size="xl"
          isOpen={modalOpen1}
          toggle={() => setModalOpen1(false)}
          title="Daily Activity Report"
        >
          <DARReport
            positionId={reportData.positionId}
            startDate={reportData.startDate}
          />
        </CommonModal>

        {/* <div className="table-responsive">
          <table className="table table-bordered text-center align-middle">
            <thead className="table-success">
              <tr>
                <th className="text-nowrap px-2">Emp Code</th>
                <th>Emp Name</th>
                <th>Designation</th>
                <th>HQ</th>

                {dates.map((date, index) => (
                  <th className="text-nowrap" key={index}>
                    {date}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {displayedData.length > 0 ? (
                displayedData.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td>{row.employee_code}</td>
                    <td className="text-nowrap">{row.employee_name}</td>
                    <td>{row.position_name}</td>
                    <td>{row.hq}</td>

                    {dates.map((displayDate, i) => {
                      const attendanceEntry = Object.values(
                        row.attendance,
                      ).find((att: any) => att.date === displayDate) as any;

                      const status = attendanceEntry?.status || "NA";

                      return (
                        <td
                          key={i}
                          title={attendanceEntry?.remarks || ""}
                          className={`small  fw-normal  ${
                            status === "YES"
                              ? "bg-success text-white"
                              : status === "NO"
                                ? "bg-danger text-white"
                                : status === "WEEK OFF"
                                  ? "bg-warning text-dark"
                                  : status === "CL" ||
                                      status === "PL" ||
                                      status === "SL"
                                    ? "bg-warning text-dark"
                                    : ""
                          }`}
                        >
                          {status}
                        </td>
                      );
                    })}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={dates.length + 4}>
                    {loading ? "Loading..." : "No attendance data available"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div> */}
      </Card>
    </div>
  );
};

export default EmployeeAttendaceReport;
